import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  Order,
  OrderFile,
  FileUploadStatusEnum,
  RXForm,
} from "src/app/shared/models/order.model";
import { UiService } from "src/app/shared/services/ui.service";
import { UploadService } from "src/app/shared/services/upload.service";
import { FileUpload } from "src/app/shared/models/common";
import { SharedService } from "src/app/shared/services/shared.service";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/shared/services/auth.service";
import { BroshService } from "src/app/shared/services/brosh.service";
import { Router } from "@angular/router";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { Store } from "@ngrx/store";
import { SELECT_RX_FORM, SET_DISPLAYED_FILE, CLEAR_DISPLAYED_FILE } from "src/app/shared/ngrx/ngrx-actions";
import { curRXForm, ui_direction, currentDisplayedFileId } from "src/app/shared/ngrx/ngrx-selectors";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { TooltipDirective } from "src/app/shared/components/ui/tooltip.directive";
import { SpinnerComponent } from "src/app/shared/components/ui/spinner/spinner.component";
import { FileIconComponent } from "src/app/shared/components/file-icon/file-icon.component";
import { DialogModule } from "primeng/dialog";
import { FilePreviewComponent } from "../file-preview/file-preview.component";
import mime from "mime";
import mimedb from "mime-db";

@Component({
  selector: "order-files",
  templateUrl: "./order-files.component.html",
  styleUrls: ["./order-files.component.scss"],
  imports: [
    TranslateModule,
    TableComponent,
    CommonModule,
    TooltipDirective,
    SpinnerComponent,
    FileIconComponent,
    DialogModule,
    FilePreviewComponent,
  ],
  standalone: true,
})
export class OrderFilesComponent implements OnInit {
  @Input() order: Order;
  @Input() subtitle?: String;
  @Input() isRX: boolean = false;
  @Input() allowUpload: boolean;
  @Input() fromRx: boolean;
  @Output() onFileUploaded = new EventEmitter();
  @Input() isScrollable: boolean = true;

  routeEnum: RouteEnum = new RouteEnum();
  onFileClickedCaller;
  isValidFile: boolean = undefined;
  isUploading: boolean;
  uplSubscription: Subscription;
  titleStr: string;
  filePopupDisplay: boolean;
  selectedFile: OrderFile;
  fileUploading: boolean;
  validFileTypes: string[] = [];
  validFileTypesStr: string;
  creatingRX: boolean;
  currentDisplayedFileId = currentDisplayedFileId;

  get files(): OrderFile[] {
    let files = this.isRX ? this.order.filesRX : this.order.files;
    if (this.fromRx) {
      return files.filter(
        (f) => f.formId != this.store.selectSignal(curRXForm)().formId
      );
    } else {
      return files;
    }
  }

  get showCreateRx(): boolean {
    return (
      this.order.allowCreateRxSw &&
      (this.isRX || this.authService.currentUser.isClinicUser)
    );
  }

  get dialogPosition(): string {
    if (this.fromRx) {
      return "left";
    } else {
      return this.store.selectSignal(ui_direction)() === "rtl" ? "right" : "left";
    }
  }

  constructor(
    private uploadService: UploadService,
    private authService: AuthService,
    private sharedService: SharedService,
    private broshService: BroshService,
    public readonly store: Store,
    private router: Router,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    let validTypes = [
      "application/pdf",
      "text/html",
      "image/jpeg",
      "image/png",
      "image/webp",
      "video/x-msvideo",
      "video/mp4",
      "video/mpeg",
      "video/webm",
    ];
    validTypes.forEach((t) => {
      var data = mimedb[t].extensions;
      this.validFileTypes.push(...data);
    });

    this.validFileTypesStr = this.validFileTypes.map((e) => "." + e).join(",");
    this.onFileClickedCaller = this.onFileClicked.bind(this);

    this.titleStr = this.isRX
      ? "translate.order.orderFilesRX"
      : "translate.order.orderFiles";
  }

  onFileClicked(file: OrderFile) {
    const displayedFileId = this.store.selectSignal(currentDisplayedFileId)();

    // If another file is displayed, close it first
    if (displayedFileId) {
      this.store.dispatch(CLEAR_DISPLAYED_FILE());
      setTimeout(() => {
        this.onFileClicked(file);
      }, 100);
      return;
    }

    if (!file.uploadStatus) {
      if (file.rxType == "DIGITAL") {
        if (!this.fromRx) {
          let form = new RXForm();
          form.formId = file.formId;

          this.store.dispatch(
            SELECT_RX_FORM({
              form: form,
            })
          );
          this.router.navigate([this.routeEnum.URL_ORDER_RX]);
        } else if (file.url) {
          this.selectedFile = file;
          this.filePopupDisplay = true;
          this.store.dispatch(SET_DISPLAYED_FILE({ fileId: file.fileId }));
        }
      } else {
        this.selectedFile = file;
        this.filePopupDisplay = true;
        this.store.dispatch(SET_DISPLAYED_FILE({ fileId: file.fileId }));
      }
    }
  }



  uploadFiles(files: any[]) {
    for (let i = 0; i < files.length; i++) {
      let newFile = new OrderFile();
      const fileData: File = files[i];
      if (!fileData) return;

      let mimeType = (mime as any).getType(fileData.name);
      let mimeSplit = mimeType.split("/")[0];
      console.log(mimeType);
      if (
        mimeSplit == "video" ||
        mimeSplit == "image" ||
        mimeType == "text/html" ||
        mimeType == "application/pdf"
      ) {
        this.isValidFile = true;
      } else {
        this.isValidFile = false;
        this.sharedService.alertInfo("translate.validation.invalidFileFormat");
        return;
      }

      this.isUploading = true;
      newFile.uploadStatus = FileUploadStatusEnum.PROGRESS;
      newFile.file = new FileUpload();
      newFile.file.fileType = this.uploadService.getFileType(fileData);
      newFile.file.subFolder = SharedService.attachmentSubFolder;

      this.files.push(newFile);

      this.uploadSingleFileWithPresignedUrl(newFile, files[i]);
    }
  }

  onFilesSelected($event) {
    if ($event.target.files.length == 0) {
      return;
    }

    this.uploadFiles($event.target.files);

    $event.target.value = "";
  }

  onFilesDropped($event) {
    this.uploadFiles($event);
  }

  checkFilesUploadStatus() {
    let cnt = this.files.filter(
      (f) => f.uploadStatus == FileUploadStatusEnum.PROGRESS
    ).length;
    if (cnt == 0) {
      this.isUploading = false;
      this.onFileUploaded.emit();
    }
  }

  uploadSingleFileWithPresignedUrl(orderFile: OrderFile, fileData: File) {
    (async () => {
      const file: FileUpload = new FileUpload();
      file.fileType = this.uploadService.getFileType(fileData);
      file.subFolder = SharedService.attachmentSubFolder;
      await this.uploadService.uploadFile(fileData);
      file.file = fileData;

      this.uplSubscription = this.uploadService
        .getPresignedUrl(file, true)
        .subscribe(
          (data) => {
            console.log(data);
            this.uploadService.putFile(file, data.uploadUrl).subscribe(
              (res) => {
                this.uploadService.copyUploadFile(data.s3Key).subscribe(
                  (res) => {
                    this.broshService
                      .uploadCustOrderFile(this.order, file, this.isRX)
                      .subscribe(
                        (data) => {
                          orderFile.uploadStatus = FileUploadStatusEnum.SUCCESS;
                          this.checkFilesUploadStatus();
                        },
                        (err) => {
                          this.alertUploadErr(orderFile, err);
                        }
                      );
                  },
                  (err) => {
                    this.alertUploadErr(orderFile, err);
                  }
                );
              },
              (err) => {
                this.alertUploadErr(orderFile, err);
              }
            );
          },
          (err) => {
            this.alertUploadErr(orderFile, err);
          }
        );
    })();
  }

  alertUploadErr(orderFile: OrderFile, err: any) {
    this.sharedService.alertError(err);
    orderFile.uploadStatus = FileUploadStatusEnum.ERROR;
    this.checkFilesUploadStatus();
  }

  ngOnDestroy() {
    if (this.uplSubscription) this.uplSubscription.unsubscribe();
  }

  createRX() {
    if (this.creatingRX) return;
    this.creatingRX = true;
    this.broshService
      .createRXForm(this.order.orderId, this.isRX ? false : true)
      .subscribe(
        (formId) => {
          this.creatingRX = false;
          this.onFileUploaded.emit();
          let form = new RXForm();
          form.formId = formId;
          this.store.dispatch(
            SELECT_RX_FORM({
              form: form,
            })
          );
          this.router.navigate([this.routeEnum.URL_ORDER_RX]);
        },
        (err) => {
          this.creatingRX = false;
        }
      );
  }
}
